import { useMutation } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { useAnalytics } from '../../../hooks/analytics/use-analytics';
import type {
  IGoodsReceivingExtractionService,
  SuggestExpiryDateInput,
  SuggestExpiryDateResponse,
} from '../../../services/goods-receiving/goods-receiving.types';
import { GoodsReceivingExtractionService } from '../../../services/goods-receiving/goods-receiving-extraction.service';

export function useSuggestExpiryDate() {
  const service = useInjection<IGoodsReceivingExtractionService>(GoodsReceivingExtractionService);
  const { trackEvent } = useAnalytics();

  return useMutation<SuggestExpiryDateResponse, Error, SuggestExpiryDateInput>({
    mutationFn: (input) => service.suggestExpiryDate(input),
    onSuccess: () => {
      trackEvent('ai_expiry_suggestion', { accepted: true });
    },
  });
}
